import { Fragment, useEffect, useState } from "react";
import _ from "lodash";

import HexButton from "../../ui-kit/HexButtons";
import { getLabel } from "../../hooks/use-labels";

import WalletProcessor from "./WalletProcessor";
import SavedCards from "./SavedCards";
import PaystackProcessor from "./PaystackProcessor";


import { WALLET_TOPUP_PURPOSE } from "../../utils/constants";
import { performWalletTransaction } from "./WalletProcessor/api-handler";
import { performSavedCardTransaction } from "./SavedCards/api-handler";
import HexLoader from "../HexLoader";
import { fetchSupportedCurrencies } from "../../redux/reducers/order/order-action";
import {
  getCurrencyGateways,
  getSupportedMethods,
} from "./payment-process-utils";
import { performCODTransaction } from "./CashOnDelivery/api-handler";
import CashOnDelivery from "./CashOnDelivery";

import "./style.css";
const PaymentProcessor = (props) => {
  const { onFailure, onSuccess, className, ...restProps } = props;
  const [methodDetails, setMethodDetails] = useState({});
  const [loading, setLoading] = useState(true);

  const [supportedGateways, setSupportedGateways] = useState([]);

  useEffect(() => {
    fetchSupportedCurrencies()
      .then(({ data }) => {
        const { currency } = restProps;

        const currencyGateways = getCurrencyGateways(
          currency,
          data.currencyGateways
        );

        setSupportedGateways(currencyGateways);
        setLoading(false);
      })
      .catch(console.error);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPaymentSuccessful = (transId) => {
    setLoading(false);
    const transIds = [transId];
    onSuccess && onSuccess(transIds);
  };

  const onPaymentFailure = (error) => {
    setLoading(false);
    onFailure(error);
  };

  const onPay = () => {
    const { method, ...restDetails } = methodDetails;

    const methodTransactionProps = {
      requestDetails: restDetails,
      onSuccess: onPaymentSuccessful,
      onFailure: onPaymentFailure,
    };

    setLoading(true);
    const paymentTransaction = {
      WALLET: () => performWalletTransaction({ ...methodTransactionProps }),
      COD: () => performCODTransaction({ ...methodTransactionProps }),
      SAVED_CARDS: () =>
        performSavedCardTransaction({ ...methodTransactionProps }),
    };

    paymentTransaction[method]();
  };

  const onChangeMethod = (details) => {
    setMethodDetails(details);
  };

  const processorProps = {
    ...restProps,
    onPaymentFailure,
    onPaymentSuccessful,
    supportedGateways,
  };

  const { supportWallet, supportCOD, supportPaystack } =
    getSupportedMethods(supportedGateways);

  const paymentProps = {
    ...processorProps,
    onChange: onChangeMethod,
    methodDetails,
  };

  const isTopUp = props.purpose === WALLET_TOPUP_PURPOSE;
  return (
    <div className={`payment-methods ${className}`}>
      {!isTopUp && supportWallet && <WalletProcessor {...paymentProps} />}

      {!isTopUp && supportCOD && <CashOnDelivery {...paymentProps} />}

      {supportPaystack && (
        <Fragment>
          <SavedCards {...paymentProps} />

          <PaystackProcessor {...processorProps} />
        </Fragment>
      )}

      {loading && <HexLoader />}

      <HexButton
        label={methodDetails.method === "COD"? getLabel("placeOrderLabel"): getLabel("payNowLabel")}
        disable={loading || _.isEmpty(methodDetails)}
        onClick={onPay}
        type="primary"
        size="md"
        htmlType="submit"
        className="full-width pay-now-button mt-24"
      />
    </div>
  );
};

export default PaymentProcessor;
